import addGenericErrorToast from './addGenericErrorToast';

export default (error) => {
  error.response?.data?.errors?.forEach(({ message }) => console.log(message));
  addGenericErrorToast();
};
